import { useState, useRef } from 'react';
import cn from 'bem-cn';

import { useIsHydrated } from '../../../hooks';
import { Icon } from '../Icon';

import { useTruncate } from './Cut.hooks';
import { CutButtonProps, CutProps } from './Cut.types';
import './Cut.scss';

const b = cn('cut');

const CutButton = (props: CutButtonProps) => {
    const { className, rotated, onClick } = props;

    return (
        <button className={b('button').mix(className)} onClick={onClick}>
            <Icon name="arrowDown" size={12} className={b('icon', { rotated })} />
        </button>
    );
};

export const Cut = (props: CutProps) => {
    const { children: content, className, buttonClassName, maxLines, defaultExpanded = false } = props;

    const contentRef = useRef<HTMLDivElement>(null);
    const [expanded, setExpanded] = useState(defaultExpanded);
    const isHydrated = useIsHydrated();

    const { truncatedContent, needsTruncation } = useTruncate({
        contentRef,
        expanded,
        maxLines,
        content,
    });

    // До гидратации используем CSS line-clamp, после – обрезаем через JS
    const useCssClamp = !isHydrated && !expanded;
    const displayContent = isHydrated && truncatedContent ? truncatedContent : content;

    function handleToggle() {
        setExpanded(prev => !prev);
    }

    return (
        <div className={b.mix(className)}>
            <div
                ref={contentRef}
                className={b('content', { expanded, 'css-clamp': useCssClamp })}
                style={useCssClamp ? { WebkitLineClamp: maxLines } : undefined}
            >
                <span>{displayContent}</span>
                {isHydrated && truncatedContent && <span className={b('ellipsis')}>...</span>}
                {isHydrated && needsTruncation && (
                    <CutButton className={buttonClassName} onClick={handleToggle} rotated={expanded} />
                )}
            </div>
        </div>
    );
};
